<template>
  <div class="road-list-total">
    <div class="road-list-total_title" @click="switchOpen">
      红色研学路线
      <img
        class="road-list-total_title_icon"
        :class="{ 'road-list-total_title_icon--open': isOpen }"
        src="../../assets/img/icon_roadlisttotal.png"
        alt=""
      />
    </div>
    <div
      class="road-list-total_content"
      :class="{ 'road-list-total_content--open': isOpen }"
    >
      <div
        class="road-list-total_content_item"
        v-for="(item, index) in roadList"
        :key="index"
      >
        {{ item.name }}
        <div
          class="road-list-total_content_item_button"
          @click="clickItem(index)"
        >
          查看详情
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['roadList'],
  data() {
    return {
      isOpen: true,
    }
  },
  methods: {
    switchOpen() {
      this.isOpen = !this.isOpen
    },
    clickItem(index) {
      this.$emit('clickItem', index)
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/css/pc.scss';
.road-list-total {
  width: rem(300);
  position: fixed;
  left: rem(24);
  top: rem(330);
  z-index: 3;
  .road-list-total_title {
    cursor: pointer;
    width: 100%;
    height: rem(50);
    line-height: rem(50);
    padding-left: rem(40);
    box-sizing: border-box;
    font-size: rem(20);
    color: rgba(32, 32, 32, 1);
    font-family: 'my-font';
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      #fbf0eb 52%,
      #ffebe2 76%,
      #ffe4d7 100%
    );
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    &::after {
      content: '';
      width: 2px;
      height: 14px;
      background: linear-gradient(
        178deg,
        #d6562e 0%,
        #cd1a2e 44%,
        #800019 100%
      );
      position: absolute;
      top: 50%;
      transform: translateY(-53%);
      left: rem(20);
    }
  }
  .road-list-total_title_icon {
    position: absolute;
    right: rem(20);
    top: 50%;
    transform: translateY(-50%) rotate(-180deg);
    display: block;
    width: rem(30);
    height: rem(30);
    transition: all 0.2s;
  }
  .road-list-total_title_icon--open {
    transform: translateY(-50%) rotate(0deg);
  }
  .road-list-total_content {
    width: rem(300);
    height: rem(485);
    background: rgba(32, 17, 17, 0.4);
    border: 1px solid rgba(251, 240, 235, 1);
    position: absolute;
    top: 2px;
    left: 0;
    border-radius: 4px;
    transition: all 0.2s;
    padding-top: rem(50);
    box-sizing: border-box;
    transform: scaleY(0);
    transform-origin: center top;
  }
  .road-list-total_content--open {
    transform: scaleY(1) rotate(0.1deg);
  }
  .road-list-total_content_item {
    width: rem(255);
    height: rem(55);
    line-height: rem(55);
    color: rgba(32, 32, 32, 1);
    font-size: rem(18);
    padding: 0 rem(10);
    box-sizing: border-box;
    border-radius: 5px;
    background: linear-gradient(
      180deg,
      #ffffff 0%,
      #fbf0eb 39%,
      #ffebe2 75%,
      #ffe4d7 100%
    );
    margin: rem(14) auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .road-list-total_content_item_button {
    cursor: pointer;
    width: rem(75);
    height: rem(40);
    line-height: rem(40);
    text-align: center;
    color: rgba(255, 255, 255, 1);
    font-size: rem(16);
    border-radius: 5px;
    background: linear-gradient(
      180deg,
      #ff5d3c 0%,
      #cd1a2e 44%,
      #80001aa2 100%
    );
  }
}
</style>
